<template>
  <div
    class="basket__delivery col-1-3"
    v-if="cart && cart.items.length"
  >
    <div class="list" v-if="cart.totals">
      <div class="list__element">
        <span class="list__label">Netto</span>
        <span class="list__value">{{
          formatCash(cart.totals.items)
        }}</span>
      </div>
      <div class="list__element">
        <span class="list__label">Wysyłka</span>
        <span class="list__value">{{
          formatCash(cart.totals.shipping)
        }}</span>
      </div>
      <div class="list__element">
        <span class="list__label">VAT</span>
        <span class="list__value">{{
          formatCash(cart.totals.taxes)
        }}</span>
      </div>
      <div class="list__element list__element--bold">
        <span class="list__label">Razem</span>
        <span class="list__value list__value--bold">{{ total }}</span>
      </div>
    </div>
    <div
      class="element"
      v-if="
        cart.shipping_selected !== 'cart' && shippingMethods.shipments
      "
    >
      <div class="text text--label">Opcje dostawy</div>

      <validation-provider rules="required" v-slot="{ errors }">
        <div
          v-for="(shippment, index) in shippingMethods.shipments[0].methods"
          :key="index"
        >
          <input
            type="radio"
            v-model="shippmentMethod"
            :value="shippment.code"
            :id="`shippment_method_${shippment.code}`"
          />
          <label
            :for="`shippment_method_${shippment.code}`"
            class="element__method"
          >
            <span class="element__name">{{ shippment.name }}</span>
            <span class="element__price">
              <span v-if="shippment.price.current > 0">+&nbsp;</span>
              {{ formatCash(shippment.price.current) }}
            </span>
          </label>
        </div>
        <FormError :errors="errors" v-show="!loading" />
      </validation-provider>
    </div>
    <ButtonPrimary class="button--big button--width" :disabled="submitting">
      <svg xmlns="http://www.w3.org/2000/svg" width="18.108" height="18.006" viewBox="0 0 18.108 18.006" v-bind:svg-inline="''" v-bind:class="'button__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="a" d="M0 6.568h18.108c-.093.509-.177.988-.268 1.466q-.722 3.8-1.448 7.605a2.8 2.8 0 01-2.807 2.357q-4.553.018-9.107 0a2.776 2.776 0 01-2.768-2.259C1.13 12.774.58 9.808.018 6.841A2.509 2.509 0 010 6.568zm9.561 1.185v2.4h3.05v-2.4zm-1.229 2.4V7.772H5.461v2.382zM9.555 13.5h3.056v-2.117H9.556zm.008 3.271h3.057v-2.034H9.564zm-1.221-5.386H5.466v2.123h2.876zm5.508-1.211c.743 0 1.446.006 2.149-.008a.33.33 0 00.257-.168c.155-.735.288-1.474.432-2.237h-2.837l-.001 2.413zM1.392 7.757c.149.781.285 1.512.434 2.239a.256.256 0 00.174.167c.739.011 1.477.007 2.221.007V7.757zm6.934 9.031v-2.05H5.46v2.05zm5.525-5.413v2.152c.54 0 1.057.006 1.572-.007a.256.256 0 00.19-.15c.137-.657.257-1.317.386-1.994zm-9.637 2.143v-2.13H2.081c.139.736.272 1.434.4 2.13zm9.638 1.214v2.018a1.749 1.749 0 001.448-2.018zm-9.623 0H2.76c-.01.994.51 1.976 1.468 2.006zM13.873 2.254a1.572 1.572 0 00-1.451-.84c-.185-.006-.372-.01-.557-.01s-.371 0-.556.011h-.086c-.192-.008-.3-.086-.381-.307a1.627 1.627 0 00-1.524-1.1C9.228 0 8.887 0 8.798 0a1.627 1.627 0 00-1.524 1.1c-.085.221-.189.3-.381.307a.784.784 0 01-.086 0c-.185-.009-.37-.012-.556-.011s-.372 0-.557.01a1.572 1.572 0 00-1.451.84c-.6 1.225-1.137 2.485-1.734 3.809.21 0 .391.011.558.009a1.9 1.9 0 00.29-.022c.106-.018.222-.166.275-.282.413-.907.823-1.818 1.213-2.735a1.047 1.047 0 011.07-.721q1.566.01 3.133.01h3.149a1.047 1.047 0 011.07.721c.389.918.8 1.828 1.213 2.735.053.116.169.265.275.282a1.808 1.808 0 00.29.022c.167 0 .348-.009.558-.009-.594-1.326-1.128-2.585-1.73-3.811z"/></svg>
      <span>Zamawiam</span>
    </ButtonPrimary>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/scss/components/payments";
</style>

<script>
import { ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { mapActions, mapGetters } from "vuex";
import { getterTypes } from "@/store/modules/Cart/getter-types";
import { actionTypes } from "@/store/modules/Cart/action-types";
import { actionTypes as orderActionTypes } from "@/store/modules/Order/action-types";
import { getterTypes as orderGetterTypes } from "@/store/modules/Order/getter-types";
import { actionTypes as addressActionTypes } from "@/store/modules/Address/action-types";
import { helperMixin } from "@/mixins/helpers.js";

extend("required", {
  ...required,
  message: "Pole jest wymagane...",
});

export default {
  name: "BasketDelivery",
  mixins: [helperMixin],
  props: {
    invalid: {
      type: Boolean,
    },
    submitting: {
      type: Boolean,
    }
  },
  components: {
    ButtonPrimary: () => import("@/pages/components/buttons/ButtonPrimary"),
    FormError: () => import("@/pages/components/FormError"),
    ValidationProvider,
  },
  computed: {
    cart() {
      return this.GET_CART();
    },
    shippingMethods() {
      return this.GET_SHIPPING_METHODS();
    },
    total() {
      const total = this.cart.totals.shipping + this.cart.totals.taxes + this.cart.totals.items - this.cart.totals.promotion;
      return this.formatCash(total);
    },
    shippmentMethod: {
      get() {
        const shippmentSelected =
          this.GET_CART().shipments && this.GET_CART().shipments.length > 0
            ? this.GET_CART().shipments[0].method.code
            : false;
        return shippmentSelected;
      },
      set(value) {
        this.loading = true;
        this.ADD_SHIPPMENT_METHOD({
          method: value,
        }).finally(() => {
          this.FETCH_CART().finally(() => {
            this.loading = false;
          });
        });
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapGetters("CartModule", [getterTypes.GET_CART]),
    ...mapActions("CartModule", [actionTypes.FETCH_CART]),
    ...mapActions("AddressModule", [addressActionTypes.FETCH_ADDRESS]),
    ...mapActions("OrderModule", [
      orderActionTypes.ADD_CHECKOUT_ADDRESS,
      orderActionTypes.ADD_SHIPPMENT_METHOD,
    ]),
    ...mapGetters("OrderModule", [
      orderGetterTypes.GET_SHIPPING_METHODS,
      orderGetterTypes.GET_SHIPPMENT_METHOD,
    ]),
  },
};
</script>